
import { defineComponent } from "vue";
import { toolbarWidthFluid } from "@/core/helpers/config";

export default defineComponent({
  name: "KToolbar",
  props: {
    breadcrumbs: Array,
  	pageButtons: Array,
  	backButton: Object,
    title: String,
  },
  components: {
  },
  setup() {
    return {
      toolbarWidthFluid,
    };
  },
});
